module.exports = __webpack_public_path__ + "media/empty-states/registrationFields-7acb6ca4.png";